import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
//
//
//
//
//
//
//
//
//
//
//

var currentEnv = process.env.APP_ENV || process.env.NODE_ENV;
var isProd = currentEnv === 'production';
var cookieBannerConfig = {
  mode: isProd ? 'production' : 'development'
};
var myIcons = {
  'cp_dashboard': 'img:/statics/cp_dashboard.svg',
  'cp_dashboard_blue': 'img:/statics/cp_dashboard_blue.svg',
  'cp_loans': 'img:/statics/cp_loans.svg',
  'cp_loans_blue': 'img:/statics/cp_loans_blue.svg',
  'cp_card': 'img:/statics/cp_card.svg',
  'cp_orange_card': 'img:/statics/cp_orange_card.svg',
  'cp_dash_card': 'img:/statics/cp_dash_card.svg',
  'cp_tnxs_blue': 'img:/statics/cp_tnxs_blue.svg',
  'cp_dash_card_blue': 'img:/statics/cp_dash_card_blue.svg',
  'cp_tnxs': 'img:/statics/cp_tnxs.svg',
  'cp_tnks_black': 'img:/statics/cp_tnks_black.svg',
  'cp_logout': 'img:/statics/cp_logout.svg',
  'cp_balance': 'img:/statics/cp_balance.svg',
  'cp_phone': 'img:/statics/cp_phone.svg',
  'cp_visa': 'img:/statics/cp_visa.svg',
  'cp_visa_electron': 'img:/statics/cp_visa_electron.svg',
  'cp_switch': 'img:/statics/cp_switch.svg',
  'cp_mastercard': 'img:/statics/cp_mastercard.svg',
  'cp_checked_shield_green': 'img:/statics/cp_checked_shield_green.svg',
  'cp_contract': 'img:/statics/cp_contract.svg',
  'cp_date_closed': 'img:/statics/cp_date_closed.svg',
  'cp_loan_amount': 'img:/statics/cp_loan_amount.svg',
  'cp_checked_shield_grey': 'img:/statics/cp_checked_shield_grey.svg',
  'cp_visa_card': 'img:/statics/cp_visa_card.svg',
  'cp_master_card': 'img:/statics/cp_master_card.svg',
  'cp_coins': 'img:/statics/cp_coins.svg',
  'cp_mb_logo': 'img:/statics/cp_mb_logo.svg',
  'cp_missile': 'img:/statics/cp_missile.svg',
  'cp_new_card': 'img:/statics/cp_new_card.svg',
  'cp_desktop_dashboard': 'img:/statics/cp_desktop_dashboard.svg',
  'cp_paper': 'img:/statics/cp_paper.svg'
};
export default {
  name: 'App',
  data: function data() {
    return {
      cookieBannerConfig: cookieBannerConfig
    };
  },
  computed: {
    shouldShowCookieBanner: function shouldShowCookieBanner() {
      return this.$store.getters['cookiebot/shouldShowCookieBanner'];
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Allow Cookiebot's native preferences dialog to be visible only after the
            // user explicitly opens it via our custom banner. The CSS in
            // index.template.html keeps it hidden until this class is set, which
            // prevents the auto-show flash on page load.
            document.addEventListener('cookie-banner:manage-preferences', function () {
              document.body.classList.add('cookiebot-loaded');
            });
            if (!(_this.$oauth.isAuthenticated() && !_this.$store.state.users.currentUser)) {
              _context.next = 1;
              break;
            }
            _context.next = 1;
            return _this.$store.dispatch('users/getCurrentUser');
          case 1:
            if (_this.$oauth.isAuthenticated()) {
              _this.$store.dispatch('holidays/getHolidays');
            }
            _this.$q.iconMapFn = function (iconName) {
              var icon = myIcons[iconName];
              if (icon !== void 0) {
                return {
                  icon: icon
                };
              }
            };
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};